import React from "react";
import Herofirst from "./herofirst";
import Herosecond from "./herosecond";
import Herothird from "./herothird";
import Herofourth from "./herofourth";
import Herofive from "./herofive";
import Herosix from "./Herosix";

const HeroSection = () => {
  return (
    <div>
      <Herofirst />
      <Herosecond />
      <Herothird />
      <Herofourth />
      <Herofive />
      <Herosix />
    </div>
  );
};

export default HeroSection;
